// LIVE-RECORDING-VIDEO-LIBRARY-1 · 녹화·영상 관리 표시 헬퍼.
export const fmtBytes = (b) => {
  if (b === null || b === undefined) return '확인 중';
  const n = Number(b);
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)}KB`;
  if (n < 1024 ** 3) return `${(n / 1024 / 1024).toFixed(1)}MB`;
  return `${(n / 1024 ** 3).toFixed(2)}GB`;
};

export const fmtLen = (sec) => {
  if (sec === null || sec === undefined) return '-';
  const s = Math.round(Number(sec));
  const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); const r = s % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}` : `${m}:${String(r).padStart(2, '0')}`;
};

export const REC_TONE = { completed: 'green', interrupted: 'amber', recording: 'red', verifying: 'amber', failed: 'red', missing: 'gray' };

export const sourceLabel = (src) => (src === 'clean'
  ? '클린 녹화 · 카메라·마이크 원본 (방송 Overlay 미포함)'
  : '방송 화면 그대로 녹화 · 녹화 시점 화면 구성 포함');
